<template>
  <div>
    <head-navigation />
    <!-- <div>what?</div> -->
    <router-view></router-view>
    <foot />
  </div>
</template>

<script>
import Foot from "../components/footer/index";
import HeadNavigation from "../components/head/index";
export default {
  name: "layout",
  components: {
    Foot,
    HeadNavigation,
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/layout/index.vue